import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/api.service';
import { ResponseInterface } from 'app/modules/models/response.model';

@Injectable({providedIn: 'root'})
export class HomeService {

    constructor(private _apiService: ApiService) { }

    getEstadisticas(){
        const url = `/carrera/estadisticas`
        return new Promise((resolve, reject) => {
            this._apiService.GetMethod(url, {}, 'Error al obtener datos')
                .subscribe( (response:ResponseInterface) => {
                    resolve( response.data)
                }, error => reject(error))
        })
    }

}
